// extracted by mini-css-extract-plugin
export default {"button":"Login_button__0Y7G3","buttonRegisterCompany":"Login_buttonRegisterCompany__VKwHo"};